import { MESSAGES } from 'src/modules/common/constants.ts';
import { UserSettings } from 'src/types/UserSettings.ts';
import { Accessory } from 'src/common/prepareAccessories.ts';
import { CheckoutPageData, ComboData } from 'src/modules/checkout/CheckoutPageMapping.ts';
import { UserInput } from 'src/modules/user-input/types.ts';
import { prepareExportAttributes } from 'src/modules/checkout/prepareExportAttributes.ts';
import { ExportTable } from 'shared/projects/ExportTable.ts';
import { shapeSelectionExportTable } from 'src/projects/utils/shapeSelectionExportTable.ts';
import { AttributesAliases } from 'src/generated/dict.ts';
import { AttributesListItemMulti } from 'src/utils/createAttributesItem.ts';

export const prepareValvesSelectionExportTable = ({
    accessories,
    userSettings,
    actuator,
    valve,
    combo,
    qty,
    userInputState,
} :
{
    userSettings: UserSettings;
    accessories: Accessory<CheckoutPageData['vssAccessories']['valveAccessories']['0']>[];
    actuator: CheckoutPageData['vssAccessories']['actuator'];
    valve: CheckoutPageData['vssAccessories']['valve'];
    combo: ComboData;
    qty: number;
    userInputState: UserInput;
}): ExportTable => {
    const attr = prepareExportAttributes(
        valve,
        actuator,
        userInputState,
    );

    const pipeConnections: AttributesListItemMulti[] = 'kvs' in valve ? [
        [AttributesAliases.pipeConnection, valve.pipeConnection],
    ] : [];

    return shapeSelectionExportTable({
        attr: [
            [MESSAGES.Type, valve.type],
            [MESSAGES.Pattern, valve.pattern],
            ...pipeConnections,
            [MESSAGES.Fluid, valve.fluid],
            [MESSAGES.OperationMode, valve.operationMode],
            ...attr,
        ],
        userSettings,
        accessories,
        locationState: { qty },
        product: combo,
    });
};
